module.exports = __webpack_public_path__ + "static/media/icon_rounded_square_active.c5f97bd8.svg";